module.exports = __webpack_public_path__ + "static/media/icn-canvasers-social-selected.2d2cd309.svg";